import isEmpty from 'lodash/fp/isEmpty';
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Collapse } from 'react-bootstrap';
import text, { formatCurrency } from '../../../text';
import { IconButton } from '../../button';
import List from '../../list/List';
import MemberDiscounts from './MemberDisounts';
import useData from './useData';
export var ExpandedDetails = function(param) {
    var toggleIcon = param.toggleIcon, toggleInvoiceSummary = param.toggleInvoiceSummary, isInvoiceExpanded = param.isInvoiceExpanded, hasTbc = param.hasTbc;
    var _orderTotals_price, _orderTotals_price1, _orderTotals_price2;
    var _useData = useData(), quote = _useData.quote, currentUser = _useData.currentUser, isEssentialUser = _useData.isEssentialUser, orderTotals = _useData.orderTotals, discounts = _useData.discounts, memberTax = _useData.memberTax, nonMemberTax = _useData.nonMemberTax, otherDiscountsTotal = _useData.otherDiscountsTotal, currency = _useData.currency, fullPriceWithSalesHelpIncGst = _useData.fullPriceWithSalesHelpIncGst, gstPercentage = _useData.gstPercentage;
    var removeConcatenatedDiscountAmout = function(str) {
        return str.replace(/\s*\(.*?\)\s*/g, '');
    };
    return !isEmpty(quote) && !isEmpty(currentUser) ? // Collapse clickable header
    /*#__PURE__*/ React.createElement("div", {
        className: "InvoiceTotalSumArea w-100"
    }, !hasTbc && /*#__PURE__*/ React.createElement("div", {
        className: classNames('price-estimate-header', {
            'pb-2': isInvoiceExpanded
        }),
        onClick: toggleInvoiceSummary
    }, /*#__PURE__*/ React.createElement("div", {
        className: "label text-uppercase green-1",
        style: {
            fontWeight: 600,
            fontSize: '12px'
        }
    }, text('priceEstimate')), /*#__PURE__*/ React.createElement("div", {
        className: "value"
    }, /*#__PURE__*/ React.createElement("div", {
        className: classNames('font-weight-bold mr-1 spans-container', {
            isEssentialUser: isEssentialUser
        }),
        style: {
            fontSize: '12px'
        }
    }, "(", /*#__PURE__*/ React.createElement("span", {
        className: "mr-1"
    }, text(isEssentialUser ? 'memberSaved' : 'membersSave'), ":", ' '), /*#__PURE__*/ React.createElement("span", null, formatCurrency(((orderTotals === null || orderTotals === void 0 ? void 0 : (_orderTotals_price = orderTotals.price) === null || _orderTotals_price === void 0 ? void 0 : _orderTotals_price.member_discount_total) + (isEssentialUser ? otherDiscountsTotal.subtotal : 0)) * gstPercentage, currency.name, currency.scale_factor, {}, true)), ")"), /*#__PURE__*/ React.createElement(IconButton, {
        iconProps: {
            isOriginal: true
        },
        icon: toggleIcon,
        onClick: toggleInvoiceSummary,
        className: "p-0"
    }))), /*#__PURE__*/ React.createElement(Collapse, {
        in: isInvoiceExpanded,
        timeout: 50
    }, /*#__PURE__*/ React.createElement("div", {
        id: "ExpandedCheckoutBoxWrapper"
    }, !isEssentialUser && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MemberDiscounts, {
        hasTbc: hasTbc
    }), /*#__PURE__*/ React.createElement("hr", {
        className: "divider mx-0"
    })), /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        className: "is-borderless mt-2"
    }, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(List.Item, {
        description: text('fullPriceWithSalesHelpInGst'),
        value: hasTbc ? /*#__PURE__*/ React.createElement("span", {
            className: "grey-3"
        }, text('toBeConfirmed')) : formatCurrency(fullPriceWithSalesHelpIncGst, currency.name, currency.scale_factor, {}, true),
        className: "font-weight-bold"
    }))), isEssentialUser ? /*#__PURE__*/ React.createElement(MemberDiscounts, null) : null, /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        className: "is-borderless"
    }, /*#__PURE__*/ React.createElement("tbody", null, discounts.selfServiceDiscountIncGst > 0 && !isEssentialUser ? /*#__PURE__*/ React.createElement(List.Item, {
        description: text('inAppSelfServeDiscount', {
            discount: 10
        }),
        value: "-".concat(formatCurrency(discounts.selfServiceDiscountIncGst, currency.name, currency.scale_factor, {}, true)),
        className: "grey-3"
    }) : null, orderTotals === null || orderTotals === void 0 ? void 0 : orderTotals.discounts.map(function(discount, index) {
        return /*#__PURE__*/ React.createElement(List.Item, {
            key: index,
            description: "".concat(removeConcatenatedDiscountAmout(discount.display_name), " (inc GST)"),
            value: "-".concat(formatCurrency(discount.price.discount, currency.name, currency.scale_factor, {}, true)),
            className: "grey-3"
        });
    }))), /*#__PURE__*/ React.createElement("hr", {
        className: "divider mx-0"
    }), /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        className: "is-borderless mt-2 mb-2"
    }, /*#__PURE__*/ React.createElement("tbody", null, /*#__PURE__*/ React.createElement(List.Item, {
        description: text('subtotal'),
        value: formatCurrency((isEssentialUser ? orderTotals === null || orderTotals === void 0 ? void 0 : (_orderTotals_price1 = orderTotals.price) === null || _orderTotals_price1 === void 0 ? void 0 : _orderTotals_price1.member_subtotal : orderTotals === null || orderTotals === void 0 ? void 0 : (_orderTotals_price2 = orderTotals.price) === null || _orderTotals_price2 === void 0 ? void 0 : _orderTotals_price2.subtotal) - otherDiscountsTotal.subtotal, currency.name, currency.scale_factor, {}, true)
    }), /*#__PURE__*/ React.createElement(List.Item, {
        description: text('gst'),
        value: formatCurrency((isEssentialUser ? memberTax : nonMemberTax) - otherDiscountsTotal.gst, currency.name, currency.scale_factor, {}, true)
    })))))) : null;
};
ExpandedDetails.propTypes = {
    toggleIcon: PropTypes.string,
    toggleInvoiceSummary: PropTypes.func,
    isInvoiceExpanded: PropTypes.bool,
    hasTbc: PropTypes.bool
};
ExpandedDetails.defaultProps = {
    toggleIcon: 'caret-down',
    toggleInvoiceSummary: function() {
        return null;
    }
};
